import { Injectable, Type } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DialogOptions, DialogsComponentOpenData } from '../interfaces/dialog-data.interface';

const defaultOptions: DialogOptions = { size: 480, layout: 'popup', style: 'light', spacingX: 60, spacingY: 40 };
export declare interface OnGetData {
  dialogName: string;
  onGetData?: (data: unknown, close: (...args) => void) => void;
  dialogOptions(): DialogOptions;
}
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private _dialogOpen: Subject<DialogsComponentOpenData> = new BehaviorSubject<DialogsComponentOpenData>(undefined);
  public readonly onDialogOpen: Observable<DialogsComponentOpenData> = this._dialogOpen.asObservable();
  private _dialogClose: Subject<boolean> = new BehaviorSubject<boolean>(undefined);
  public readonly onDialogClose: Observable<boolean> = this._dialogClose.asObservable();
  dialogOpen: boolean;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) this.close();
    });
  }

  open<T>(component: Type<T>, data?: unknown) {
    const _options = component.prototype.dialogOptions?.() || {};
    this.dialogOpen = true;
    return new Promise(resolve => {
      const options: DialogOptions = { ...defaultOptions, ..._options };
      this._dialogOpen.next({ component, data, options, resolve });
    });
  }

  close() {
    this._dialogClose.next(true);
    this.dialogOpen = false;
  }
}
